import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupBaseComponent } from '../components/popup-templates/popup-base/popup-base.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConfirmationPopupComponent } from '../components/popup-templates/confirmation-popup/confirmation-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { MessagePopupComponent } from '@shared/modules/popup/components/popup-templates/message-popup/message-popup.component';

export interface ButtonOptions {
  buttonLabel: string;
}

export interface ConfirmationButtonOptions {
  cancelButton?: ButtonOptions;
  confirmButton?: ButtonOptions;
  extraOptionButton?: ButtonOptions;
}

export interface MessageButtonOptions {
  actionButton?: ButtonOptions;
}

export interface MessageTypeOptions {
  type: 'error' | 'warning' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  public messagePopups = new BehaviorSubject<Array<any>>([]);

  constructor(private modalService: NgbModal, private translate: TranslateService) { }

  showComponentPopup(component: any, data: any, options?: any, uniqueIdentifier?: any) {
    if (!options) {
      options = { windowClass: '', backdrop: 'true', centered: true };
    } else {
      options.keyboard = false;
      options.backdrop = 'static';
    }

    if (!uniqueIdentifier) {
      // SonarQube: This is not a security-sensitive use of Math.random()
      // NOSONAR
      uniqueIdentifier =
        Math.random() //NOSONAR
          .toString(36)
          .substring(2) + Date.now().toString(36); //NOSONAR
    } // NOSONAR
    const modalRef = this.modalService.open(PopupBaseComponent, options);
    modalRef.result.then(() => {
      this.onCloseComponentPopup(uniqueIdentifier);
    });

    this.messagePopups.next([...this.messagePopups.getValue(), { uniqueIdentifier, modalRef }]);
    // console.log(this.messagePopups.getValue());

    modalRef.componentInstance.component$ = component;
    modalRef.componentInstance.data$ = data;
    modalRef.componentInstance.options$ = options;

    return modalRef;
  }

  showConfirmationPopup(
    confirmationTitle: string,
    confirmationText: string,
    confirmationButtons: ConfirmationButtonOptions
  ) {
    return this.showComponentPopup(ConfirmationPopupComponent, {
      confirmationTitle,
      confirmationText,
      confirmationButtons
    });
  }

  showMessagePopup(
    messageTitle: string,
    messageText: string,
    messageTypeOptions: MessageTypeOptions,
    messageButtons: MessageButtonOptions,
    uniqueIdentifier?: any
  ) {
    return this.showComponentPopup(
      MessagePopupComponent,
      {
        messageTitle,
        messageText,
        messageTypeOptions,
        messageButtons
      },
      null,
      uniqueIdentifier
    );
  }

  onCloseComponentPopup(uniqueIdentifier: any) {
    console.info('Dismissed component popup - ' + uniqueIdentifier);
    this.messagePopups.next([...this.messagePopups.getValue().filter(p => p.uniqueIdentifier !== uniqueIdentifier)]);
    // console.log(this.messagePopups.getValue());
  }

  getOpenComponentPopup(modalRef?: any, uniqueIdentifier?: any) {
    if (modalRef) {
      return this.messagePopups.getValue().find(p => p.modalRef === modalRef);
    } else if (uniqueIdentifier) {
      return this.messagePopups.getValue().find(p => p.uniqueIdentifier === uniqueIdentifier);
    }
  }

  hasOpenPopups() {
    return this.modalService.hasOpenModals();
  }

  dismissAllPopups(reason?: any) {
    this.modalService.dismissAll(reason);
  }
}
